export function ratingAccriss(rating: string): string {

  if(!rating) {
    return 'N/A';
  }

  let ratingStr: string = '';

  ratingStr = rating.split('/')[0];

  return ratingStr || 'N/A';

}

export function initArrayIncludesCoverageRentACar(included: any): any[] {

    const arrayIncludes: any[] = [];

    const priceCoverages = included;

    if (priceCoverages) {
      priceCoverages.forEach((coverage) => {
        arrayIncludes.push(coverage);
      });

    }

    return arrayIncludes;

}
